module.exports = __webpack_public_path__ + "static/img/balz707-663-32583.d9a706f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/balz707-663-32583.jpg
// module id = TWpH
// module chunks = 0